<template>
	<v-dialog @keydown.esc="closeDialog()" v-show="dialogShowModel" v-model="dialogShowModel" :width="computedWidth" :fullscreen="$vuetify.breakpoint.xsOnly || fullscreen" absolute persistent :content-class="classes" :overlay-opacity="$store.getters.isDarkMode ? 0.9 : 0.5" v-bind="$attrs">
		<slot />
	</v-dialog>
</template>
<script>
export default {
	props: {
		dialogShowModel: {
			type: Boolean,
			default: false,
		},
		large: {
			type: Boolean,
			default: false,
		},
		fullscreen: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes() {
			if (this.$vuetify.breakpoint.xsOnly || this.fullscreen) {
				return "fullscreen-material-dialog material-dialog";
			}
			return "material-dialog";
		},
		isLarge() {
			if (this.large) {
				return true;
			}
			if (this.$vuetify.breakpoint.mdAndDown) {
				return true;
			}
			return false;
		},
		computedWidth() {
			let screenwidth = this.$vuetify.breakpoint.width;
			let minimum = 0;
			let value = 0;
			if (this.isLarge) {
				value = this.$appOptions.largeDialogsWidthPercentage();
				minimum = this.$appOptions.largeDialogsWidth();
				if ((screenwidth * value) / 100 < minimum) {
					value = minimum;
				} else {
					value += "%";
				}
			} else {
				value = this.$appOptions.dialogsWidthPercentage();
				minimum = this.$appOptions.dialogsWidth();
				if ((screenwidth * value) / 100 < minimum) {
					value = minimum;
				} else {
					value += "%";
				}
			}
			return value;
		},
	},
	methods: {
		closeDialog() {
			this.$emit("escintent");
		},
	},
};
</script>
